import React, {useContext, useEffect, useState} from "react";
import {ScreenDesignerContextNew} from "../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import ComponentsByType from "./ComponentsByType";

const OtherComponents = () => {
    const {
        screenValues: {otherComponents = []},
        onSelectComponent, onDeleteComponent
    } = useContext(ScreenDesignerContextNew);

    const [components, setComponents] = useState({entity: [], context: [], interval: [], webSocket: [], dataSource: [], shortcut: []});
    useEffect(() => {
        const store = {
            entity: [],
            context: [],
            interval: [],
            webSocket: [],
            dataSource: [],
            shortcut: []
        }
        for(let [index, item] of otherComponents.entries()) {
            store[item.type].push({item, index});
        }
        // otherComponents.forEach((item, index) => {
        //     store[item.type].push({item, index});
        // });
        setComponents(store)
    }, [JSON.stringify(otherComponents)]);

    return (
        <div>
            <ComponentsByType
                components={components.entity}
                label={'Entities'}
                defaultItemLabel={'Entity'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
            <ComponentsByType
                components={components.context}
                label={'Context Menus'}
                defaultItemLabel={'Context'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
            <ComponentsByType
                components={components.interval}
                label={'Intervals'}
                defaultItemLabel={'Interval'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
            <ComponentsByType
                components={components.webSocket}
                label={'Web Sockets'}
                defaultItemLabel={'Web Socket'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
            <ComponentsByType
                components={components.dataSource}
                label={'Data Source'}
                defaultItemLabel={'Data Source'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
            <ComponentsByType
                components={components.shortcut}
                label={'Shortcut'}
                defaultItemLabel={'Shortcut'}
                onDeleteComponent={onDeleteComponent}
                onSelectComponent={onSelectComponent}
            />
        </div>
    )
};

export default OtherComponents